import { useState } from 'react';
import { p as parse24HourTime } from './time-utils/parse24HourTime-BkOQgi4-.js';
import { c as compose24HourTime } from './time-utils/compose24HourTime-xEwgsVO0.js';

const TimeInputState = ({
  children,
  onChange,
  value
}) => {
  const [dateParts, setDateParts] = useState(parse24HourTime(value));
  const onChangeHour = hour => {
    const {
      minute,
      meridiem
    } = dateParts;
    onChange(compose24HourTime({
      hour,
      minute,
      meridiem
    }));
    setDateParts({
      ...dateParts,
      hour
    });
  };
  const onChangeMinute = minute => {
    const {
      hour,
      meridiem
    } = dateParts;
    onChange(compose24HourTime({
      hour,
      minute,
      meridiem
    }));
    setDateParts({
      ...dateParts,
      minute
    });
  };
  const onChangeMeridiem = meridiem => {
    const {
      hour,
      minute
    } = dateParts;
    onChange(compose24HourTime({
      hour,
      minute,
      meridiem
    }));
    setDateParts({
      ...dateParts,
      meridiem
    });
  };
  const {
    hour: propsHour,
    minute: propsMinute,
    meridiem: propsMeridiem
  } = parse24HourTime(value);
  return children({
    hour: propsHour !== null && propsHour !== void 0 ? propsHour : dateParts.hour,
    minute: propsMinute !== null && propsMinute !== void 0 ? propsMinute : dateParts.minute,
    meridiem: propsMeridiem !== null && propsMeridiem !== void 0 ? propsMeridiem : dateParts.meridiem,
    onChangeHour,
    onChangeMinute,
    onChangeMeridiem
  });
};

export { TimeInputState as T };
//# sourceMappingURL=CustomTimeInputState-B68FA0Ot.js.map
